import {HTMLSelect} from "@blueprintjs/core";
import React from "react";

import {
    DataType,
    IMAGE_TYPE,
    STRING_TYPE,
} from "../../../stores/database-template/database-form-base";
import {bindInput} from "../../../utils/bind-input";
import {isPersistedId} from "../../../utils/is-presisted-id";
import {TrashIconButton} from "../../atoms/buttons/buttons";
import {Td, Tr} from "../../atoms/tables/table";
import {FormField} from "../inputs/form-field";

type DatabaseRowProps = {
    isEdit?: boolean;
    id: string;
    /** 項目ID */
    slug: string;
    /** 項目ID のエラーメッセージ */
    slugError?: string;
    /** 項目ID が変わったとき */
    onSlugChange: (id: string, newItemId: string) => void;
    /** 項目名 */
    label: string;
    /** 項目名 のエラーメッセージ */
    labelError?: string;
    /** 項目名 が変わったとき */
    onLabelChange: (id: string, newName: string) => void;
    /** データの種類（"STRING" | "IMAGE" など） */
    type: DataType;
    /** データの種類 が変わったとき */
    onDataTypeChange: (id: string, newType: DataType) => void;
    /** 説明 */
    note: string;
    /** 説明 のエラーメッセージ */
    noteError?: string; //
    /** 説明 が変わったとき */
    onDescriptionChange: (id: string, newDesc: string) => void;
    /** ゴミ箱アイコン押下で行を削除するとき */
    onRemove: (id: string) => void;
    /** 行を削除できるかどうか */
    canRemove: boolean;
};
const DatabaseRow = ({
    isEdit = false,
    id,
    slug,
    slugError,
    onSlugChange,
    label,
    labelError,
    onLabelChange,
    type,
    onDataTypeChange,
    note,
    noteError,
    onDescriptionChange,
    onRemove,
    canRemove,
}: DatabaseRowProps) => {
    const isReadOnly = isEdit && isPersistedId(id);
    return (
        <Tr>
            {/* 新規作成の場合は<Td>は表示させない */}
            {/* 編集の場合はAPIで取得したIDは表示 フォーム追加により生成したUUIDは非表示 */}
            {isEdit && <Td>{isPersistedId(id) && id}</Td>}
            <Td>
                <FormField
                    noLabel
                    placeholder="項目名ID"
                    value={slug}
                    {...bindInput((newSlug) => onSlugChange(id, newSlug))}
                    errorText={slugError}
                />
            </Td>
            <Td>
                <FormField
                    noLabel
                    placeholder="項目名"
                    value={label}
                    {...bindInput((newLabel) => onLabelChange(id, newLabel))}
                    errorText={labelError}
                />
            </Td>
            <Td>
                <HTMLSelect
                    data-testid="dataType"
                    disabled={isReadOnly}
                    value={type}
                    onChange={(e) => {
                        onDataTypeChange(id, e.currentTarget.value as DataType);
                    }}
                >
                    <option value={STRING_TYPE}>STRING</option>
                    <option value={IMAGE_TYPE}>IMAGE</option>
                </HTMLSelect>
            </Td>
            <Td>
                <FormField
                    noLabel
                    placeholder="説明"
                    value={note}
                    errorText={noteError}
                    {...bindInput((newDesc) => onDescriptionChange(id, newDesc))}
                />
            </Td>
            <Td style={{textAlign: "center"}}>
                {canRemove && <TrashIconButton onClick={() => onRemove(id)} />}
            </Td>
        </Tr>
    );
};

export default DatabaseRow;
